import React from 'react';
import { getAllErrorMessages } from 'services/TenantSubmitHandler';

interface ErrorMessagesProps {
  apiResponse: String[] | null;
}



const ErrorMessages: React.FC<ErrorMessagesProps> = ({ apiResponse }) => {
  const messages = getAllErrorMessages(apiResponse);

  if (messages.length === 0 && apiResponse?.length === 0) return null;

  return (
    <>
        {
            apiResponse && apiResponse.length > 0 && (
                <div className="bg-red-100 border border-red text-red p-20px radius-5px">
                <ul className="mb-0">
                    {apiResponse.map((msg, index) => (
                    <li key={index}>{msg}</li>
                    ))}
                </ul>
                </div>
            )
        }
    </>
  );
};

export default ErrorMessages;